import styled from "styled-components";

export const CheckoutWrapper = styled.section`
  width: 60%;
  margin: 3rem auto;
  text-align: center;
`;

export const CheckoutH2 = styled.h2`
  display: block;
  margin: 0 auto;
  font-size: clamp(3rem, 2.5vw, 4.8rem);
  text-align: center;
`;
